import React, { useState, useEffect } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import LoadingPopup from "./loading";

const MySwal = withReactContent(Swal2);

const swalCrm = {
  customClass: {
    popup: "swal-crm-popup",
    title: "swal-crm-title",
    htmlContainer: "swal-crm-html",
    confirmButton: "swal-crm-confirm",
    cancelButton: "swal-crm-cancel",
    actions: "swal-crm-actions",
    input: "swal-crm-input",
  },
};

const SendLeadsDetails = (props) => {
  const [loading, setLoading] = useState(true);
  const [mailTable, setMailTable] = useState([]);
  const [sendTable, setSendTable] = useState([]);
  const [sendSum, setSendSum] = useState(0);
  const [send, setSend] = useState(true);
  const [statuses, setStatuses] = useState([]);

  const checkLead = async () => {
    await fetch("https://apiftpsplit.ftpeople.pl/checkLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify({ leads: props.leads, clients: props.clients }),
    })
      .then((response) => response.json())
      .then((data) => fetchSendLeads2(data));
  };

  const fetchSendLeads2 = async (arrX) => {
    const arr = [];
    let sum = 0;

    props.clients.forEach((client) => {
      const leads = props.leads.filter(
        (lead) =>
          arrX.filter(
            (el) => el.mail === lead.mail && +client.id === +el.companyId
          ).length === 0
      );
      const leadsNon = props.leads
        .filter(
          (lead) =>
            arrX.filter(
              (el) => el.mail === lead.mail && +client.id === +el.companyId
            ).length > 0
        )
        .map((lead) => ({
          lead,
          assDate: arrX.find((el) => el.mail === lead.mail)?.assDate,
        }));

      arr.push({
        leads,
        leadsNon,
        name: client.name,
        mail: client.mail,
        price: client.price,
        id: client.id,
      });
      sum += client.price * leads.length;
    });

    setSendSum(sum);

    const arr2 = props.leads
      .filter((lead) => lead.mail !== "")
      .map((lead) => ({
        mail: lead.mail,
        name: lead.name,
        type: props.sendOption,
        companies: arr
          .filter(
            (el) =>
              el.leads.some((eq) => eq.id === lead.id) &&
              !el.name.includes("FTP")
          )
          .map((el) => el.name),
      }));

    setMailTable(arr2);
    setSendTable(arr);
    fetchStatuses();
  };

  const fetchStatuses = async () => {
    await fetch("https://apiftpsplit.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify({}),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        setLoading(false);
      })
      .catch(() => {});
  };

  useEffect(() => {
    checkLead();
  }, []);

  const handleSend = () => {
    const model = {};
    statuses.forEach((el) => {
      model[el.name] = el.name;
    });

    MySwal.fire({
      title: "Wybierz status",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      ...swalCrm,
      inputValidator: (value) =>
        new Promise((resolve) =>
          resolve(value !== "" ? undefined : "Musisz wybrać wartość")
        ),
    }).then((result) => {
      if (!result.isConfirmed) return;

      fetch("https://apiftpsplit.ftpeople.pl/sendLeads", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify({
          mailTable,
          sendTable,
          type: props.sendOption,
          status: result.value,
          send,
        }),
      }).catch(() => {});

      MySwal.fire({
        icon: "success",
        title: "Wysłano",
        text: "kontakty",
        ...swalCrm,
      }).then(() => props.close());
    });
  };

  const hasLeads = sendTable.some((el) => el.leads.length > 0);

  return (
    <div className="ld-modal-overlay">
      <div className="ld-modal" style={{ maxWidth: 800 }}>
        {loading ? (
          <LoadingPopup />
        ) : (
          <>
            {/* Header */}
            <div className="ld-header">
              <div className="ld-header-info">
                <div className="ld-avatar">WK</div>
                <div>
                  <h2 className="ld-name">Wysyłka kontaktów</h2>
                  {sendSum > 0 && (
                    <div className="ld-header-meta">
                      <span>
                        Łączna wartość:{" "}
                        <strong style={{ color: "var(--brand)" }}>
                          {sendSum} zł netto
                        </strong>
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <button
                className="ld-close"
                onClick={props.close}
                title="Zamknij"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            {/* Clients list */}
            <div className="ld-content" style={{ padding: "20px 24px" }}>
              <div className="sld-clients">
                {sendTable.map((client) => (
                  <div key={client.id} className="sld-client">
                    {/* Client header */}
                    <div className="sld-client-header">
                      <div className="sld-client-info">
                        <span className="sld-client-name">{client.name}</span>
                        <span className="sld-client-mail">{client.mail}</span>
                      </div>
                      <span className="sld-client-value">
                        {client.price * client.leads.length} zł netto
                      </span>
                    </div>

                    {/* Leads */}
                    {client.leads.length > 0 ? (
                      <div className="sld-leads">
                        {client.leads.map((lead) => (
                          <div key={lead.id} className="sld-lead">
                            {lead.name}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="sld-empty">Brak leadów do wysyłki</p>
                    )}

                    {/* Duplicates */}
                    {client.leadsNon.length > 0 && (
                      <div className="sld-dupes">
                        <div className="sld-dupes-header">
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                          </svg>
                          Usunięte z wysyłki — duplikaty
                        </div>
                        {client.leadsNon.map((item, i) => (
                          <div key={i} className="sld-dupe">
                            {item.lead.name}
                            <span className="sld-dupe-date">
                              {item.assDate}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Footer actions */}
              <div className="sld-footer">
                <label className="sld-check-label">
                  <input
                    type="checkbox"
                    className="db-check"
                    style={{ margin: 0 }}
                    checked={send}
                    onChange={() => setSend((v) => !v)}
                  />
                  Wyślij wiadomość do kontaktów
                </label>

                {hasLeads && (
                  <button
                    className="lq-btn lq-btn--success sld-send-btn"
                    onClick={handleSend}
                  >
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <line x1="22" y1="2" x2="11" y2="13" />
                      <polygon points="22 2 15 22 11 13 2 9 22 2" />
                    </svg>
                    Wyślij kontakty
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SendLeadsDetails;
